<template>
<div>
  <div id="wjdcEdit" v-if="editFlag">
      <div id="wjdcView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="wjdc2Form" :model="wjdc2Form" label-position="right" label-width="0px" :rules="wjdc2Rules">
          <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel" >企业分布</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="qyfb" style="text-align: left" class="is-required">
                <el-select size="small" v-model="wjdc2Form.qyfb" class="searchSelect" clearable placeholder="全部">
                  <el-option v-for="item in qyfbData" :key="item.codeValue" :label="item.codeName" :value="item.codeValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">成立年限</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="clnx" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.clnx" size="small" auto-complete="off">
                  <el-radio v-for="item in clnxData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <!-- <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">实收资本</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="sszb" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.sszb" size="small" auto-complete="off">
                  <el-radio v-for="item in sszbData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row> -->
          <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">收入规模</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="srgm" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.srgm" size="small" auto-complete="off">
                  <el-radio v-for="item in srgmData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">人员规模</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="rygm" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.rygm" size="small" auto-complete="off">
                  <el-radio v-for="item in rygmData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <!-- <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">知识产权情况</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="zscqqk" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.zscqqk" size="small" auto-complete="off">
                  <el-radio v-for="item in zscqqkData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row> -->
          <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">研发和信息化年均投入占比</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="yftrzb" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.yftrzb" size="small" auto-complete="off">
                  <el-radio v-for="item in yftrzbData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <!-- <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">不良记录</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="bljl" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.bljl" size="small" auto-complete="off">
                  <el-radio v-for="item in bljlData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row> -->
          <!-- <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">社会责任报告/可持续发展报告/ESG报告</span>
            </el-col>
            <el-col :span="17">
              <el-form-item prop="shzrbg" style="text-align: left">
                <el-radio-group v-model="wjdc2Form.shzrbg" size="small" auto-complete="off">
                  <el-radio v-for="item in shzrbgData" :label="item.codeValue" :key="item.codeValue" class="radio">
                    <span v-text="item.codeName"></span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row> -->
          <!-- <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">国内已参展次数</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="gnyczcs" style="text-align: left">
                <el-input size="small" v-model="wjdc2Form.gnyczcs" placeholder="国内已参展次数" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">
              <span class="vbm" style="color:red">*</span>
              <span class="mr5 vbm yxLabel">国外已参展次数</span>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="gwyczcs" label="" style="text-align: left">
                <el-input size="small" v-model="wjdc2Form.gwyczcs" placeholder="国外已参展次数" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
          </el-row> -->
          <el-row class="buttonSubmit">
            <el-col :span="24">
              <!-- <el-button type="info" icon="el-icon-arrow-left" size="small" class="btn_submit" @click="cancelWjdc('wjdc2Form')">上一步</el-button>
              <el-button type="success" size="small" class="btn_submit" @click="submitWjdc('wjdc2Form')">下一步&nbsp;
                <i class="el-icon-arrow-right"></i>
              </el-button> -->

              <el-button v-if="wjdc2Data.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">取消</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitWjdc('wjdc2Form')">保存</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </div>
  <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
    <div id="qywjdc2" class="mb5">
        <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="21">
            <el-row class="mb10">
              <el-col :span="12">
                <strong>企业分布：</strong>
                <span v-text="wjdc2Data.qyfbmc||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>成立年限：</strong>
                <span v-text="wjdc2Data.clnxmc||'无'"></span>
              </el-col>
             
            </el-row>
           <!-- <el-row class="mb10">
               <el-col :span="12">
                <strong>成立年限：</strong>
                <span v-text="wjdc2Data.clnxmc||'无'"></span>
              </el-col> 
              <el-col :span="12">
                <strong>实收资本：</strong>
                <span v-text="wjdc2Data.sszbmc||'无'"></span>
              </el-col> 
            </el-row>-->
            <el-row class="mb10">
              <el-col :span="12">
                <strong>收入规模：</strong>
                <span v-text="wjdc2Data.srgmmc||'无'"></span>
              </el-col>
              <el-col :span="12">
                <strong>人员规模：</strong>
                <span v-text="wjdc2Data.rygmmc||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
               <!-- <el-col :span="12">
                <strong>知识产权情况：</strong>
                <span v-text="wjdc2Data.zscqqkmc||'无'"></span>
              </el-col> -->
              <el-col :span="12">
                <strong>研发和信息化年均投入占比：</strong>
                <span v-text="wjdc2Data.yftrzbmc||'无'"></span>
              </el-col>
            </el-row>
            <el-row class="mb10">
            
              <!-- <el-col :span="12">
                <strong>社会责任报告/可持续发展报告/ESG报告：</strong>
                <span v-text="wjdc2Data.shzrbgmc||'无'"></span>
              </el-col> -->
            </el-row>
            
         
          </el-col>
          <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">编辑</el-button>
            </el-col>
        </el-row>
      </div>
  </div>

</div>
</template>

<script>
export default {
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  name: "wjdc2Edit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //问卷调查2表单
      wjdc2Form: {
        uuid: "",
        qyfb: "",
        clnx: "",
        sszb: "",
        srgm: "",
        rygm: "",
        zscqqk: "",
        yftrzb: "",
        bljl: "",
        shzrbg: "",
        gnyczcs: "",
        gwyczcs: "",
      },
      wjdc2Rules: {
        qyfb: [
          { required: true, message: "请选择企业分布", trigger: "change" }
        ],
        clnx: [
          { required: true, message: "请选择成立年限", trigger: "change" }
        ],
        sszb: [
          { required: true, message: "请选择实收资本", trigger: "change" }
        ],
        srgm: [
          { required: true, message: "请选择收入规模", trigger: "change" }
        ],
        rygm: [
          { required: true, message: "请选择人员规模", trigger: "change" }
        ],
        zscqqk: [
          { required: true, message: "请选择知识产权情况", trigger: "change" }
        ],
        yftrzb: [
          { required: true, message: "请选择研发和信息化年均投入占比", trigger: "change" }
        ],
        bljl: [
          { required: true, message: "请选择不良记录", trigger: "change" }
        ],
        shzrbg: [
          { required: true, message: "请选择社会责任报告/可持续发展报告/ESG报告", trigger: "change" }
        ],
        gnyczcs: [
          { required: true, message: "请输入国内已参展次数", trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "国内已参展次数应为正整数",
            trigger: "blur"
          }
        ],
        gwyczcs: [
          { required: true, message: "请输入国外已参展次数", trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "国外已参展次数应为正整数",
            trigger: "blur"
          }
        ],
      },
      // 企业分布
      qyfbData: [],
      // 成立年限
      clnxData: [],
      // 实收资本
      sszbData: [],
      // 收入规模
      srgmData: [],
      // 人员规模
      rygmData: [],
      // 知识产权情况
      zscqqkData: [],
      // 研发和信息化年均投入占比
      yftrzbData: [],
      // 不良记录
      bljlData: [],
      // 社会责任报告/可持续发展报告/ESG报告
      shzrbgData: [],

      editFlag: false,
      //企业问卷调查二
      wjdc2Data: {},
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findWjdcByQyid(this.qyid);
      }
    }
  },
  created () {
    this.getDMJData();
    //this.findWjdcByQyid(this.qyid);
  },
  methods: {
   // 通过代码集获取选择框数据
    getDMJData () {
      this.$axios.get("/codelist/getCodetype/XZQH").then((res) => {
        this.qyfbData = res.data.result.filter(item => {
          return item.codeValue.substr(-4) == "0000"
        });
      });
      this.$axios.get("/codelist/getCodetype/CLNX").then((res) => {
          this.clnxData = res.data.result;
      });
      this.$axios.get("/codelist/getCodetype/SSZB").then((res) => {
          this.sszbData = res.data.result;
      });
      this.$axios.get("/codelist/getCodetype/SRGM").then((res) => {
          this.srgmData = res.data.result;
      });
      this.$axios.get("/codelist/getCodetype/RYGM").then((res) => {
          this.rygmData = res.data.result;
      });
      this.$axios.get("/codelist/getCodetype/ZSCQQK").then((res) => {
          this.zscqqkData = res.data.result;
      });
      this.$axios.get("/codelist/getCodetype/YFTRZB").then((res) => {
          this.yftrzbData = res.data.result;
      });
      this.$axios.get("/codelist/getCodetype/BLJL").then((res) => {
          this.bljlData = res.data.result;
      });
      this.$axios.get("/codelist/getCodetype/SHZRBG").then((res) => {
          this.shzrbgData = res.data.result;
      });
    },
    findWjdcByQyid (qyid) {
      this.loading = true
      let params = {
        qyid: qyid,
        deleteFlag: "N"
      }
      this.$axios.post("/qyqtwjdc/list", params).then((res) => {
        this.loading = false
        if (res.data.code === "00000000" && res.data.result.length > 0) {
          this.wjdc2Data = JSON.parse(JSON.stringify(res.data.result[0]));

          this.wjdc2Form = res.data.result[0];

          if(res.data.result[0].validateFlag == 'T'){
                this.editFlag = false;
            }else{
                this.editFlag = true;
            }
        }else{
          this.editFlag = true;
        }
      })
    },
    //问卷调查上一步
    cancelWjdc () {
      this.$emit("getActive",  2);
    },
    //问卷调查提交（下一步）
    submitWjdc (formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("保存失败，请先填写企业基本信息后再填写其他信息", '提示', {
          confirmButtonText: '确定'
        });
      }else{
        this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          var params = {
            ...this.wjdc2Form,
            qyid: this.qyid,
            xgrid: this.currentUser.userid,
            xgrmc: this.currentUser.username,
            validateFlag: 'T'
          };
          this.$axios.post("/qyqtwjdc/doInsertOrUpdateQtWjdcByVo", params).then(
              function(res) {
                if (res.data.result != null && res.data.result != "") {
                  this.$message({
                    message: "企业其他信息(二)暂存成功",
                    type: "success"
                  });
                 
                  this.$emit("getLoading", false);
                  //this.$emit("getActive",  4);
                  this.editFlag = false;
                  this.findWjdcByQyid(this.qyid);
                  
                } else {
                  this.$message({
                    message: "企业其他信息(二)暂存失败",
                    type: "error"
                  });
                  this.$emit("getLoading", false);
                }
              }.bind(this),
              function(error) {
                console.log(error);
              }
            );
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
   
      }
       },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findWjdcByQyid(this.qyid);
    }
  }
};
</script>

<style lang="scss">
#wjdcEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  #wjdcView .el-input-number--small{
    width: 30%;
    float: left;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEdit/Wjdc2.vue